import { useState, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { postAllData } from "../../service/ApiService";
import { validatePasswordField } from "../../config/Validate";
import { VIEW_SIN_NUMBER } from "../../config/ApiConstant";
import { Password } from "primereact/password";

interface MaskedSecureFieldProps {
  label: string;
  value: string;
}

const ViewSinNumber = ({ label, value }: MaskedSecureFieldProps) => {
  // sin no dialog
  const [visibleDialog, setVisibleDialog] = useState(false);

  // password field
  const [password, setPassword] = useState<any>();

  // error obj
  const [error, setError] = useState<any>();

  // display submit and cancel btn in dialog
  const [showReal, setShowReal] = useState<boolean>(false);
  const toast = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  //   hide sin  number
  const maskValue = (text: string) => {
    if (!text) return "-";
    return text.replace(/\d(?=\d{3})/g, "*");
  };

  //   on handle change
  const handleChange = (e: any) => {
    let val = e?.target?.value ?? e?.value;
    setPassword(val);
    setError(null);
  };

  //   submit function
  const handleVerify = async () => {
    try {
      const { errors, isError } = validatePasswordField(password);

      setError(errors.password);
      if (isError) return;
      setLoading(true);

      const payload = {
        password,
      };

      const response = await postAllData(VIEW_SIN_NUMBER, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
          className: "items-start text-left",
        });
        setShowReal(true);
        setLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
        className: "items-start text-left",
      });
    } finally {
      setLoading(false);
    }
  };

  //   close model
  const closeDialog = () => {
    setVisibleDialog(false);
    setPassword(null);
    setError(null);
    setShowReal(false);
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="flex align-items-center gap-2" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
        <span>{maskValue(value)}</span>
        <Button
          icon="pi pi-eye"
          className="p-button-text p-button-sm p-0 m-0"
          style={{ width: '2rem', height: '2rem', flexShrink: 0 }}
          onClick={() => setVisibleDialog(true)}
        />
      </div>

      <Dialog
        visible={visibleDialog}
        header={`View ${label}`}
        modal
        className="mx-3 lg:mx-0"
        style={{ width: "450px" }}
        onHide={closeDialog}
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            {!showReal && (
              <>
                <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDialog} />
                <Button label="Verify" icon="pi pi-check" className="common-primary-button" loading={loading} onClick={handleVerify} />
              </>
            )}
            {showReal && <Button label="Close" icon="pi pi-times" className="common-primary-button" onClick={closeDialog} />}
          </div>
        }
      >
        {!showReal ? (
          <div className="grid p-fluid formgrid">
            <div className="field col-12 md:col-10">
              <label>Enter Password to view {label}:</label>
              <div className="">
                <Password
                  value={password}
                  name="password"
                  placeholder="Enter Password"
                  onChange={(e) => handleChange(e)}
                  toggleMask
                  feedback={false}
                  autoComplete="off"
                  className={error && "p-invalid"}
                />
              </div>
              {error && <small className="p-error">{error}</small>}
            </div>
          </div>
        ) : (
          <h4>
            {label}: {value}
          </h4>
        )}
      </Dialog>
    </>
  );
};

export default ViewSinNumber;
